<template><div class="ai-list-container"><div class="ai-list-surface" :class="{ 'is-scrolled': scrolled }"><slot /></div><slot name="footer" /></div></template>
<script>
// Shared list shell only. Item rendering, selection and permissions stay with their owners.
export default { props: { scrolled: Boolean } }
</script>
<style scoped src="./surfaces.css"></style>
<style scoped>.ai-list-container{width:100%;min-width:0}</style>
